/* global eggoOrderLimit */

import {documentEventDispatcher, EVENT_TOGGLE_CHECKOUT} from "./eggo-cart-events";

const MIN_VALID_LIMIT = 50;

/** Hides the checkout button when the cart total (major units, after discounts) is above the configured limit. */
export const checkOrderLimit = (total) => {
    if (typeof eggoOrderLimit === "undefined" || !eggoOrderLimit?.enabled || !(eggoOrderLimit?.limit > MIN_VALID_LIMIT)) return;
    documentEventDispatcher(EVENT_TOGGLE_CHECKOUT, {
        limit: eggoOrderLimit.limit,
        total: total
    });
}

export const registerToggleCheckout = () => {
    document.addEventListener(EVENT_TOGGLE_CHECKOUT, function (event) {
        const isCartPage = document.getElementById("cart-page");
        let button = null;
        let message = null;

        if (isCartPage) {
            button = document.querySelector("#cart-page #checkout");
            message = document.querySelector("#cart-page #cart-notification-button-message");
        } else {
            button = document.querySelector(".cart-drawer__inner-real #cart-notification-button");
            message = document.querySelector(".cart-drawer__inner-real #cart-notification-button-message");
        }

        const {limit, total} = event.detail;
        if (!button) return;
        if (total > limit) {
            button.classList.add("hide");
            if (message) message.classList.add("show");
        } else {
            button.classList.remove("hide");
            if (message) message.classList.remove("show");
        }
    });
}
